import React, {Component} from 'react';
import moment from 'moment';


import './AppointmentView.css';
import Appointment from '../../api/Appointment';
import {FormLabeledItem, Button} from '../../components/FormUI';
import DateHelper from '../../components/DateHelper';
import Clinic from '../../api/Clinic';
import BiopedModal, {CardModal, ActionModal, SideModal} from '../../components/BioPedModal';
import NewAppForm from './forms/NewAppForm';

import Icon from '../../components/Icon';
import NoShow from '../NoShow';
import UserAppHistoryView from '../UserAppHistoryView';
import User from '../../api/User';
import AppointmentService from '../../api/services/AppointmentService';
import UserDetails, {DetailCard} from '../Clients/UserDetails';
import UserForm from '../Clients/forms/UserForm';
import RootModal from '../../components/RootModal';
import ColorHelper from "../../classes/ColorHelper";
import CalendarView from "../CalendarView";
import Modals from "../../components/Modals";


export default class AppointmentViewCard extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.dateHelper = new DateHelper();
		this.openEditor = this.openEditor.bind(this);
		this.onEditComplete = this.onEditComplete.bind(this);
		this.deleteApp = this.deleteApp.bind(this);
		this.handleShowHistory = this.handleShowHistory.bind(this);
		this.closeEditor = this.closeEditor.bind(this);

	}

	openEditor() {

		if (this.props.onRequestEdit) {
			this.props.onRequestEdit(this.props.appointment, this);
		} else {
			CalendarView.ShowEditAppointment(this.props.appointment);
		}
	}

	onEditComplete(app) {
		this.setState({editorOpen: false});
		if (this.props.onSave) {
			this.props.onSave(app);
		}
	}

	deleteApp() {

		return Modals.DeleteAppointmentModal(this.props.appointment);
		/*
		const deleteModal = (
			<div className="delete-app button-modal">
				<div className="modal-caption">Are you sure you want to delete this appointment?</div>
				<div className="table hmax layout-fixed button-bar">
					<div>
						<div>
							<Button className="red" caption="Yes" onClick={() => {
								let appSer = new AppointmentService();
								appSer.delete(this.props.appointment.appointmentId).then((d) => {
									CalendarView.Refresh();
									if (this.props.onSave) {
										this.props.onSave(d);
									}
								})

								RootModal.CloseModal();
							}}/>
						</div>
						<div>
							<Button caption="No" onClick={() => {
								RootModal.CloseModal()
							}}/>
						</div>
					</div>
				</div>


			</div>
		)
		const modalId = RootModal.ShowModal(deleteModal);

        */

		/*let appSer = new AppointmentService();
        appSer.delete(this.props.appointment.appointmentId).then((d) => {
            if(this.props.onSave){
                this.props.onSave(d);
            }
        })*/
	}

	handleShowHistory() {
		this.setState({
			side: <UserAppHistoryView user={new User(this.props.appointment.client)}
			                          requestClose={() => this.setState({side: null})}/>
		});
	}

	closeEditor() {
		//CalendarView.ShowEditAppointment(this.props.appointment);
		//this.setState({editorOpen:false})
	}

	showUserDetails = () => {
		this.setState({showDetails: true})
		//let app = new Appointment(this.props.appointment);
		//CalendarView.ShowUserDetails(app.client);
		let app = new Appointment(this.props.appointment);
		let client = app.client;
		if (this.props.onRequestUserDetails) {
			this.props.onRequestUserDetails(client);
		} else {
			CalendarView.ShowUserDetails(client);
		}
	}

	handleEdit = () => {
		//CalendarView.ShowEditAppointment(this.props.appointment);
		//this.setState({showEdit:true, showDetails:false});
	}

	copyApp = () => {
		if (this.props.onRequestCopy) {
			this.props.onRequestCopy(this.props.appointment);
		} else {
			CalendarView.CopyAppointment(this.props.appointment);
		}
	}

	render() {
		if (this.props.appointment == null) return null;
		let app = new Appointment(this.props.appointment);
		let client = app.client;
		let clinic = new Clinic(app.clinicId);

		if (!this.props.isOpen) {
			this.state.side = null;
		}

		let inverse = ColorHelper.GetInverse('#' + app.appointmentType.color);
		let style = {
			backgroundColor: '#' + app.appointmentType.color,
			color: inverse,
			textShadow: "0px 0px 3px " + ColorHelper.GetInverse(inverse)
		}
		let copyStyle = {
			backgroundColor: 'rgb(0 173 21)',
			color: inverse,
			textShadow: "0px 0px 3px " + ColorHelper.GetInverse(inverse),
			right: '64px'
		}
		let deleteStyle = {
			backgroundColor: 'red',
			color: inverse,
			textShadow: "0px 0px 3px " + ColorHelper.GetInverse(inverse),
			right: '118px'
		}

		return (
			<div className="appointment-view-card">
				<div className="modal-title" style={style}>
					{app.appointmentType.name} - {app.status}
					<div className="table align-middle align-center action-btn" title='Edit' onClick={this.openEditor}
					     style={style}>
						<div>
							<div><Icon icon='edit'/></div>
						</div>
					</div>
					<div className="table align-middle align-center action-btn action-btn-copy"
					     title='Copy' style={copyStyle} onClick={this.copyApp}>
						<div>
							<div><Icon icon='copy'/></div>
						</div>
					</div>
					<div className="table align-middle align-center action-btn action-btn-delete" title='Delete'
					     onClick={this.deleteApp} style={deleteStyle}>
						<div>
							<div><Icon icon='delete'/></div>
						</div>
					</div>
				</div>
				<div className="appointment-view">
					<div className='dev-app-details'>appId:{app.appointmentId}</div>
					<FormLabeledItem label="Client">
						<div className="client-name"><span title='View Details'
						                                   onClick={this.showUserDetails}>{app.client.fullName}</span>
						</div>
						<div className="table hmax">
							<div>
								<div>{client.homePhone ? "H: " + client.homePhone : ''}</div>
								<div className="align-right">{client.email ? "E: " + client.email : ''}</div>
							</div>
						</div>
					</FormLabeledItem>
					<FormLabeledItem label='Service'>
						{app.appointmentType.name}
					</FormLabeledItem>
					<div className="table hmax layout-fixed">
						<div>
							<div>
								<FormLabeledItem label='Date'>
									{moment(app.start).format('ddd MMM D, YYYY')}
								</FormLabeledItem>
							</div>
							<div>
								<FormLabeledItem label='Time'>
									{DateHelper.FormatTime(app.start)} - {DateHelper.FormatTime(app.end)}
								</FormLabeledItem>
							</div>
						</div>
						<div>
							<div>
								<FormLabeledItem label='Pedorthist'>
									{clinic.getDoctor(app.userId).fullName}
								</FormLabeledItem>
							</div>
							<div>
								<FormLabeledItem label='Status'>
									{app.status}
								</FormLabeledItem>
							</div>
						</div>
					</div>
					<FormLabeledItem label="Notes">
						<div className="comment">
							<pre>{app.comment}</pre>
						</div>
					</FormLabeledItem>
				</div>


				{/*<ActionModal title="Appointment - Edit" close='Cancel' isOpen={this.state.editorOpen} onRequestClose={this.closeEditor}>
                    <NewAppForm appointment={this.props.appointment} clinicId={app.clinicId} doctorId={app.userId} onSave={this.onEditComplete} />
                </ActionModal>*/}
				{/*<BiopedModal isOpen={this.state.showDetails} onRequestClose={() => this.setState({showDetails:false})}>
                    <DetailCard user={client} onBack={() => this.setState({showDetails:false})} />
                </BiopedModal>*/}

				{/*<BiopedModal isOpen={this.state.showDetails} onRequestClose={() => this.setState({showDetails:false})}>
                    <UserDetails hideEdit={this.props.hideEdit} user={client} backCaption='Close' onBack={() => this.setState({showDetails:false})} onEdit={this.handleEdit} />
                </BiopedModal>*/}

				{/*<ActionModal close='Close' title='Edit Patient' className='scrollable' isOpen={this.state.showEdit} onRequestClose={() => this.setState({showEdit:false})}>
                    <UserForm className='popup-form' user={client} onBack={() => this.setState({showEdit:false})} />
                </ActionModal>*/}


			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/Appointments/AppointmentViewCard.js